import _ from 'lodash'

class ConfirmationController {
  constructor(
    $routeParams,
    $analytics,
    $log,
    $location,
    flash,
    registration,
    SignupService,
    AuthService
  ) {
    this.$routeParams = $routeParams
    this.$analytics = $analytics
    this.$log = $log
    this.$location = $location
    this.signupService = SignupService
    this.authService = AuthService
    this.flash = flash
    this.password = ''
    this.email = ''
    this.submitting = false

    this.registration = registration
    if ( !registration ) {
      this.createAccountMessage = "The Registration information provided is no longer valid.  You will have to start the signup process again."
    } else {
      this.createAccountMessage = ''
    }
  }

  createAccount() {
    this.createAccountMessage = ''
    this.submitting = true
    this.signupService.createAccount(
      this.registration.registrationId,
      this.password,
      this._onCreateAccountSuccess.bind(this),
      this._onCreateAccountFailure.bind(this)
    )
  }

  _onCreateAccountSuccess(response) {
    this.authService.login(
      {password: this.password, email: response.user.email},
      this._onLoginSuccess.bind(this),
      this._onLoginFailure.bind(this))
  }

  _onLoginSuccess(response) {
    this.submitting = false
    this.$location.url('/search')
  }

  _onLoginFailure(response) {
    this.submitting = false
    this.flash.setMessage('Thank you for setting your password.  Now you can sign in to access your data')
    this.$location.url('/login')
  }

  _onCreateAccountFailure(response) {
    this.submitting = false
    this.$log.debug('error when trying to add registration data to users table', response)
    this.createAccountMessage = 'We could not create your account at this time. Please try again.'
  }

}

ConfirmationController.$inject = [
  '$routeParams',
  '$analytics',
  '$log',
  '$location',
  'flash',
  'registration',
  'SignupService',
  'AuthService'
]

export default ConfirmationController
